import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "acToast_wrapper" }
const _hoisted_2 = { class: "acToast_icon" }
const _hoisted_3 = { class: "acToast_content" }
const _hoisted_4 = { class: "acToast_title" }
const _hoisted_5 = { class: "acToast_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isActive)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['acToast', 'toast-transition', `-${_ctx.type}`, `-${_ctx.location}`, `-position-${_ctx.textPosition}`])
      }, [
        (_ctx.canClose)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "acToast_close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
            }, [...(_cache[1] || (_cache[1] = [
              _createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-d4086046><g clip-path=\"url(#clip0_2088_9251)\" data-v-d4086046><path d=\"M12.0007 10.5867L16.2437 6.34372C16.6342 5.95325 17.2673 5.95325 17.6577 6.34372V6.34372C18.0482 6.73418 18.0482 7.36725 17.6577 7.75772L13.4147 12.0007L17.6577 16.2437C18.0482 16.6342 18.0482 17.2673 17.6577 17.6577V17.6577C17.2673 18.0482 16.6342 18.0482 16.2437 17.6577L12.0007 13.4147L7.75772 17.6577C7.36725 18.0482 6.73418 18.0482 6.34372 17.6577V17.6577C5.95325 17.2673 5.95325 16.6342 6.34372 16.2437L10.5867 12.0007L6.34372 7.75772C5.95325 7.36725 5.95325 6.73418 6.34372 6.34372V6.34372C6.73418 5.95325 7.36725 5.95325 7.75772 6.34372L12.0007 10.5867Z\" fill=\"#FFFFFF\" data-v-d4086046></path></g><defs data-v-d4086046><clipPath id=\"clip0_2088_9251\" data-v-d4086046><rect width=\"24\" height=\"24\" fill=\"white\" data-v-d4086046></rect></clipPath></defs></svg>", 1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "icon", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.icon), 1)
              ], true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "title", {}, () => [
                  _createTextVNode(_toDisplayString(_ctx.title), 1)
                ], true)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "text", {}, () => [
                  _createTextVNode(_toDisplayString(_ctx.text), 1)
                ], true)
              ])
            ])
          ], true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}